import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Alumni.css";
import { Autoplay, Navigation } from "swiper/modules";
import alumni_1 from "../../assets/alumni/Afriza_Hanung.webp"
import alumni_2 from "../../assets/alumni/Halim_Febrianto.webp"
import alumni_3 from "../../assets/alumni/Hanif_Ilham.webp"
import alumni_4 from "../../assets/alumni/Hazzel_Javiera.webp"
import alumni_5 from "../../assets/alumni/Iksan_Wisnu.webp"
import alumni_6 from "../../assets/alumni/Muhammad_Alfaza.webp"
import alumni_7 from "../../assets/alumni/Muhammad_Fariz_Anugrah.webp"
import alumni_8 from "../../assets/alumni/Riyad_Fadilah.webp"
import alumni_9 from "../../assets/alumni/Yohannes_Izzy.webp"
import alumni_10 from "../../assets/alumni/laode_Zhuhri.webp"

const Alumni = () => {
  return (
    <React.Fragment>
        <div className="container-alumni" id="alumni">
        <h1 className="title-alumni">Alumni Taruna Persada</h1>
        <Swiper
          slidesPerView={4}
          spaceBetween={30}
          navigation={false}
          autoplay={{
            delay: 2500, // waktu transisi antar slide dalam milidetik
            disableOnInteraction: false, // autoplay tidak berhenti saat interaksi
          }}
          loop={true}
          modules={[Navigation, Autoplay]} // Tidak memasukkan Pagination
          breakpoints={{
            // ketika lebar layar lebih besar dari 1200px
            1200: {
              slidesPerView: 4, // 4 slides pada layar besar
              spaceBetween: 20, // ruang antar slide
            },
            // ketika lebar layar lebih besar dari 768px
            768: {
              slidesPerView: 3, // 3 slides pada layar sedang
              spaceBetween: 15, // ruang antar slide
            },
            // ketika lebar layar lebih besar dari 480px
            480: {
              slidesPerView: 2, // 2 slides pada layar kecil
              spaceBetween: 10, // ruang antar slide
            },
            // untuk layar lebih kecil dari 480px
            0: {
              slidesPerView: 2, // 1 slide pada layar kecil banget
              spaceBetween: 20, // ruang antar slide
            },
          }}
          className="mySwiperAlumni"
        >
          <SwiperSlide><img src={alumni_1} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_2} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_3} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_4} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_5} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_6} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_7} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_8} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_9} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
          <SwiperSlide><img src={alumni_10} alt="Bimbel Psikotes Masuk Polri" className="img-alumni" /></SwiperSlide>
        </Swiper>
      </div>
    </React.Fragment>
  )
}

export default Alumni